import type { BillingSummary } from '../api/FetchBillingList';
import { useBillingProcesses } from './useBillingProcesses';

export const useSelectedBillingProcess = (
  billing: BillingSummary,
  selectedProcessCode?: string,
) => {
  const { processes } = useBillingProcesses();
  const { activityCode } = billing;

  const inferredProcess = activityCode
    ? processes.find(({ activityCodes }) =>
        activityCodes.includes(activityCode),
      )
    : undefined;

  const process =
    processes.find(({ code }) => code === selectedProcessCode) ??
    inferredProcess;

  return { process, isInferred: !!process && process === inferredProcess };
};
